import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=70b15d5a&"
import script from "./settlement.vue?vue&type=script&lang=js&"
export * from "./settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports